import {makePostResendConfirmEmail} from 'main/factories/usecases';

export async function postResendEmailOtpCode(email: string) {
	return makePostResendConfirmEmail().post({
		email,
	});
}
